import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Card, LogButton } from './common';
import BloodPressureModal from './BloodPressureModal';

import rightArrow from '../../images/common/arrow-right-black.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import BloodPressureIcon from '../../images/health-content/blood-pressure-icon.svg';

const BloodPressureCard = ({ bpCard, getData }) => {
  const [showModal, setShowModal] = useState({
    showBPModal: false,
  });
  const history = useHistory();

  return (
    <Card
      onClick={() => history.push('/health-content/blood-pressure-data')}
      className="w-1/2 p-15 mt-2 health-card flex flex-col justify-between"
    >
      <div>
        <div className="flex justify-between items-start w-full">
          <img src={BloodPressureIcon} alt="weight-icon" />
          <img src={rightArrow} alt="right-arrow" className="w-6px" />
        </div>
        <h4 className="text-caption-l font-semibold mt-10">Blood Pressure</h4>
        <h1 className="text-title-l font-bold mt-1">
          {bpCard ? bpCard.value1 : 0}/{bpCard ? bpCard.value2 : 0}
        </h1>
        {bpCard && (
          <p className="font-medium text-chip text-sub mt-1">
            <img src={ClockIcon} alt="clock" className="inline" />
            &nbsp;{bpCard.measuredOn}
          </p>
        )}
      </div>
      <LogButton
        buttonText="Log New"
        onClick={(e) => {
          setShowModal((prevState) => ({
            ...prevState,
            showBPModal: true,
          }));
        }}
      />
      {showModal.showBPModal && (
        <BloodPressureModal
          // getData={getData}
          hideModal={(e) => {
            if (e) e.stopPropagation();
            setShowModal((prevState) => ({
              ...prevState,
              showBPModal: false,
            }));
          }}
          measuredOn={bpCard ? bpCard.measuredOn : ''}
        ></BloodPressureModal>
      )}
    </Card>
  );
};

export default BloodPressureCard;
